<!-- Simply Amazing Deals -->
<section class="px-15 w-full" [ngClass]="view.site?.id === 72 ? 'pt-28 md:pt-32' : ''">
    <div class="flex flex-col items-center justify-center">
        <div class="w-full flex justify-center items-center">
            <div class="w-full flex flex-row p-10 justify-between items-center">
                @if (view.site && view.site.profile && view.site.profile.heading) {
                    @switch (view.site.profile.heading.position) {
                        @case (1) {
                            <app-heading_section-type01 [options]="{heading:'Specials',title:'Simply Amazing Deals',image:'', description:'',swooshAlign: {'margin':''} }" ></app-heading_section-type01>
                            }
                        @case (2) {
                            <app-heading_section-type01 [options]="{heading:'Specials',title:'Simply Amazing Deals',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_section-type01>
                        }
                        @case (4) {
                                <app-heading_section-type01
                                    [options]="{ heading:'Specials',title:'Unbeatable Offers',image:'', description:'' }"></app-heading_section-type01>
                                }
                    }
                }
            </div>
        </div>
       
        <div class="w-[90%] m-auto">
            <ngx-slick-carousel class="carousel" 
            #slickModal="slick-carousel" 
            [config]="slideConfig" 
            (init)="slickInit($event)"
            (breakpoint)="breakpoint($event)"
            (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)">
            @for(deal of view.deals; track deal) {
                <fuse-card ngxSlickItem class="relative  bg-primary-300 m-2 isolate  h-[400px]  border-t-4 border-b-4 hover:border-primary-400 flex flex-col justify-end  px-4 pb-4 pt-4  t-24 pt-40 ">
                    <img [src]="deal.imageUrls[0]" alt="Destination Image" class="absolute inset-0 h-full w-full object-cover ">
                    <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40 "></div>
                    <div class="z-10 flex justify-between">
                        <div class="flex">
                            <mat-icon class="mat-icon-rtl-mirror icon-size-4 text-gray-100 m-1" [svgIcon]="'location_on'"></mat-icon>
                            <p class="text-gray-400">Spain , Berlin</p>
                        </div>
                        <div class="flex">
                                <!-- <div class="z-10 flex mb-2">
                                    @if(deal.supplier && deal.supplier.grading > 0 && deal.supplier.grading <= 1) {
                                        <mat-icon class="z-10 icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    }
                                </div>
                                <div class="flex mb-2">
                                    @if(deal.supplier && deal.supplier.grading > 1 && deal.supplier.grading <= 2) {
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    }
                                </div>
                                <div class="flex mb-2">
                                    @if(deal.supplier && deal.supplier.grading > 2 && deal.supplier.grading <= 3) {
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    }
                                </div>
                                <div class="flex mb-2">
                                    @if(deal.supplier && deal.supplier.grading > 3 && deal.supplier.grading <= 4) {
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    }
                                </div>
                                <div class="flex mb-2">
                                    @if(deal.supplier && deal.supplier.grading > 4 && deal.supplier.grading <= 5) {
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    }
                                </div> -->
                                    <div class="flex mb-2">
                                        <mat-icon class="icon-size-4 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-4 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-4 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-4 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-4 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                </div>
                            </div>
                    </div>
                    <h3 class="z-10  text-3xl font-bold text-white ">{{deal.destination}}</h3>
                    <div class="z-10 gap-y-2 overflow-hidden text-sm leading-6 text-gray-300">
                        <div class="flex ">
                            <div class="mr-4 flex">
                                <mat-icon class="mat-icon-rtl-mirror  icon-size-4 text-gray-300 m-1" [svgIcon]="'schedule'"></mat-icon>
                                <p class="text-gray-400">{{deal.nights}} {{deal.nights === 1 ? 'Night' : 'Nights'}}</p>
                            </div>
                            <div class="mr-4 flex"> 
                                <mat-icon class="mat-icon-rtl-mirror icon-size-4 text-gray-300 m-1" [svgIcon]="'group'"></mat-icon>
                                <p class="text-gray-400">{{deal.adults}}    {{deal.adults === 1 ? 'Adult' : 'Adults'}}</p>
                            </div>
                        </div>
                        <div class="flex justify-between  border-t border-dashed border-primary-300 ">
                            <p class="text-gray-400 pt-3">From R <span class="text-primary-500 text-sm font-semibold">{{deal.priceBundleTotal | number: '1.2-2'}}</span><sup class="mr-1">pps</sup></p>
                            <div class="pt-1 text-gray-400  hover:text-primary-500">
                            <a [routerLink]="['/package', deal.id, deal.slug ? deal.slug : slugify(deal.name)]"type="button" class="mt-3 text-base text-sm ring-primary-500 rounded-lg text-center py-1  transition text-xs cursor-pointer transition-duration: 500ms text-primary-400 hover:text-primary-700 uppercase pr-1">View More <mat-icon   class="icon-size-2 text-primary-400 group-hover:text-primary-100 transition ease-out duration-500 pt-3"  [svgIcon]="'feather:arrow-right'"
                            ></mat-icon></a>
                            </div>
                        </div>
                    </div>
                </fuse-card>
            }
            </ngx-slick-carousel>
        </div>


            
    </div>
</section>
  
